'use strict';

import React from 'react';
import createStoreMixin from '../mixins/createStoreMixin';
import StampStore from '../stores/StampStore';
import UserStore from '../stores/UserStore';
import ZineStore from '../stores/ZineStore';
import UserCuratedZineStore from '../stores/UserCuratedZineStore';
import UserCuratedUnlistedZineStore from '../stores/UserCuratedUnlistedZineStore';
import UserContributedZineStore from '../stores/UserContributedZineStore';
import UserContributedUnlistedZineStore from '../stores/UserContributedUnlistedZineStore';
import SuggestedZineStore from '../stores/SuggestedZineStore';
import ZineActionCreators from '../actions/ZineActionCreators';
import Group from '../organisms/Group';
import SidebarBody from '../organisms/SidebarBody';
import EmptyState from '../molecules/EmptyState';
import Loader from '../atoms/Loader';
import PureRenderMixin from '../mixins/PureRenderMixin';
import Button from '../atoms/Button';
import { transitionTo } from '../router';
import { PropTypes } from 'react';
import StampStatus from '../constants/StampStatus';

var AddStampToZines = React.createClass({
  mixins: [
    createStoreMixin(
      UserContributedZineStore, UserContributedUnlistedZineStore,
      UserCuratedZineStore, UserCuratedUnlistedZineStore,
      SuggestedZineStore, StampStore, ZineStore
    ),
    PureRenderMixin
  ],

  propTypes: {
    stampId: PropTypes.number.isRequired
  },

  getStateFromStores(props) {
    const stamp = StampStore.get(props.stampId);
    const me = UserStore.getMe();
    const isMyStamp = UserStore.isMe(stamp.user);
    const isPublicStamp = stamp.status === StampStatus.PUBLIC;

    const curatedStore = this.getCuratedStore(stamp);
    const curatedZines = curatedStore.getZines(me.id);

    let isReady = curatedStore.getPageCount(me.id) > 0;
    let contributedZines = [];
    let suggestedZines = [];

    const contributedStore = this.getContributedStore(stamp);
    if (isMyStamp) {
      contributedZines = contributedStore.getZines(me.id);
      isReady = isReady && contributedStore.getPageCount(me.id) > 0;

      if (isPublicStamp) {
        suggestedZines = SuggestedZineStore.getZines();
        isReady = isReady && SuggestedZineStore.getPageCount() > 0;
      }
    }

    return {
      isPublicStamp,
      stamp,
      isMyStamp,
      isReady,
      curatedZines,
      contributedZines,
      suggestedZines
    };
  },

  getCuratedStore(stamp) {
    const isPublic = stamp.status === StampStatus.PUBLIC;
    return isPublic ? UserCuratedZineStore : UserCuratedUnlistedZineStore;
  },

  getContributedStore(stamp) {
    const isPublic = stamp.status === StampStatus.PUBLIC;
    return isPublic ? UserContributedZineStore : UserContributedUnlistedZineStore;
  },

  componentDidMount() {
    var me = UserStore.getMe();

    if (this.state.isPublicStamp) {
      ZineActionCreators.requestUserCuratedPage(me.id, true);
    } else {
      ZineActionCreators.requestUserCuratedUnlistedPage(me.id, true);
    }

    if (this.state.isMyStamp) {
      if (this.state.isPublicStamp) {
        ZineActionCreators.requestUserContributedPage(me.id, true);
      } else {
        ZineActionCreators.requestUserContributedUnlistedPage(me.id, true);
      }
      ZineActionCreators.requestSuggestedPage(true);
    }
  },

  render() {
    var { isMyStamp } = this.state,
        title,
        subtitle;

    if (isMyStamp) {
      title = 'Submit to Collections';
      subtitle = (
        <span>
          Submit your Stamp to one or more relevant collections.
          <br />
          <span>You may have to wait for approval to collections curated by other users.</span>
        </span>
      );
    } else {
      title = 'Add to Collections';
      subtitle = 'Add this Stamp to one or more relevant collections.';
    }

    return (
      <SidebarBody title={title}
                   subtitle={subtitle}>
        {this.renderGroups()}
      </SidebarBody>
    );
  },

  renderGroups() {
    if (!this.state.isReady) {
      return <Loader absoluteCenter />;
    }

    const userId = UserStore.getMe().id;
    const {
      stamp,
      suggestedZines,
      contributedZines,
      curatedZines,
      isPublicStamp
    } = this.state;

    const hasCurated = curatedZines.length > 0;
    const hasContributed = contributedZines.length > 0;
    const hasSuggested = suggestedZines.length > 0;
    const curatedStore = this.getCuratedStore(stamp);
    const contributedStore = this.getContributedStore(stamp);
    const emptyLabel = isPublicStamp ?
      'Currently you are not curating any collections.' :
      'Currently you are not curating any secret collections.';

    if (!hasCurated && !hasContributed && !hasSuggested) {
      return (
        <EmptyState label={emptyLabel}
                    absoluteCenter>
          <Button onClick={this.handleCreateCollectionClick}
                  hideOnMobile>
            Create a Collection
          </Button>
        </EmptyState>
      );
    }

    return {
      curatedZines: hasCurated && (
        <Group title='My Collections'
               type='zines'
               items={curatedZines}
               context='sidebar'
               mode='grid'
               columns={2}
               itemProps={{ size: 'small', showSubmit: true, stamp: stamp }}
               isExpectingPage={curatedStore.isExpectingPage(userId)}
               isLastPage={curatedStore.isLastPage(userId)}
               isInvalidated={curatedStore.isInvalidated(userId)}
               loadNextPage={this.requestNextCuratedPage} />
      ),

      contributedZines: hasContributed && (
        <Group title='Recent Collections'
               type='zines'
               items={contributedZines}
               context='sidebar'
               mode='grid'
               columns={2}
               itemProps={{ size: 'small', showSubmit: true, stamp: stamp }}
               isExpectingPage={contributedStore.isExpectingPage(userId)}
               isLastPage={contributedStore.isLastPage(userId)}
               isInvalidated={contributedStore.isInvalidated(userId)}
               loadNextPage={this.requestNextContributedPage} />
      ),

      suggestedZines: hasSuggested && (
        <Group title='Trending Collections'
               type='zines'
               items={suggestedZines}
               context='sidebar'
               mode='grid'
               columns={2}
               itemProps={{ size: 'small', showSubmit: true, stamp: stamp }}
               isExpectingPage={SuggestedZineStore.isExpectingPage()}
               isLastPage={SuggestedZineStore.isLastPage()}
               isInvalidated={SuggestedZineStore.isInvalidated()}
               loadNextPage={this.requestNextSuggestedPage} />
      )
    };
  },

  handleCreateCollectionClick() {
    transitionTo('zineNew');
  },

  requestNextCuratedPage() {
    var userId = UserStore.getMe().id;
    if (this.state.isPublicStamp) {
      ZineActionCreators.requestUserCuratedPage(userId);
    } else {
      ZineActionCreators.requestUserCuratedUnlistedPage(userId);
    }
  },

  requestNextContributedPage() {
    var userId = UserStore.getMe().id;
    if (this.state.isPublicStamp) {
      ZineActionCreators.requestUserContributedPage(userId);
    } else {
      ZineActionCreators.requestUserContributedUnlistedPage(userId);
    }
  },

  requestNextSuggestedPage() {
    ZineActionCreators.requestSuggestedPage();
  }
});

module.exports = AddStampToZines;



/** WEBPACK FOOTER **
 ** ./sidebar/AddStampToZines.jsx
 **/